import { Component, Input } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'shop-carousels',
  templateUrl: './shop-carousels.html',
  standalone: false,
})
export class ShopCarouselComponent {
  @Input('sectionName') sectionName: any;
  @Input('translateId') translateId: string;
  @Input('viewAllSection') viewAllSection: any;
  @Input('showTags') showTags: any;
  @Input() isShopRevampExperimentOn: boolean;

  constructor(
    private eventLogger: EventLoggerService,
    private conn: ConnectionService,
  ) {}

  viewAll(pageName: string, tags?: boolean): void {
    this.eventLogger.cleverTapEvent(
      'click',
      JSON.stringify({ name: `view-all-${pageName}` }),
    );
    if (this.showTags) {
      this.conn.navigateToURL(
        `/user/order/reorder?from=${pageName}&tags=${tags}`,
      );
    } else {
      this.conn.navigateToURL(`/user/order/reorder?from=${pageName}`);
    }
  }
}
